<script>
  export let number
  export let style
</script>

<style>
  .shimmer {
    background: #f6f7f8;
    background-image: linear-gradient(
      to right,
      #f6f7f8 0%,
      #edeef1 20%,
      #f6f7f8 40%,
      #f6f7f8 100%
    );
    background-repeat: no-repeat;
    background-size: 800px 104px;
    display: inline-block;
    position: relative;

    -webkit-animation-duration: 1s;
    -webkit-animation-fill-mode: forwards;
    -webkit-animation-iteration-count: infinite;
    -webkit-animation-name: placeholderShimmer;
    -webkit-animation-timing-function: linear;
    width: 42px;
    height: 42px;
    margin-right: 8px;
    margin-bottom: 8px;
    border-radius: 4px;
    border: none;
  }
  .shimmer:last-child {
    margin-right: 0;
  }

  @keyframes placeholderShimmer {
    0% {
      background-position: -468px 0;
    }
    100% {
      background-position: 468px 0;
    }
  }
</style>

{#each [...Array(number)] as _, index (index)}
  <div class="shimmer" {style} />
{/each}
